import { Icon } from '../components/ui.js';
import type { Strings } from '../i18n/index.js';
import * as api from '../lib/api.js';

/**
 * Shown on a brand new installation instead of the pairing screen.
 *
 * Somebody opening the server address for the first time lands on the kiosk,
 * not on the admin UI - so this screen exists to say what is missing and where
 * to continue. Without it the first thing an operator sees is a code field for
 * a code that cannot exist yet, because no tenant has been created.
 */
export function SetupRequired({ strings }: { strings: Strings }): JSX.Element {
  return (
    <div className="pair-shell">
      <div className="pair-card">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
          <span className="choice-icon" style={{ width: 46, height: 46, borderRadius: 13 }}>
            <Icon name="shield" size={24} />
          </span>
          <div>
            <h1 className="section-title" style={{ margin: 0 }}>
              {strings.setupTitle}
            </h1>
            <p className="brand-sub" style={{ margin: 0 }}>
              Foyer {api.APP_VERSION}
            </p>
          </div>
        </div>

        <p className="subline" style={{ fontSize: '1rem', marginBottom: 20 }}>
          {strings.setupText}
        </p>

        <a className="btn btn-primary btn-block" href="/admin/" style={{ textDecoration: 'none' }}>
          {strings.setupButton}
        </a>

        <p className="help" style={{ marginTop: 18, textAlign: 'center' }}>
          {strings.setupAfter}
        </p>
      </div>
    </div>
  );
}
